"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
var React = __importStar(require("react"));
var react_autosize_textarea_1 = __importDefault(require("react-autosize-textarea"));
var styled_components_1 = __importDefault(require("styled-components"));
exports.TextArea = (0, styled_components_1.default)(function (props) { return React.createElement(react_autosize_textarea_1.default, __assign({}, props)); }).attrs({
    className: 'tws-editable-textarea',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t {\n\t\tborder: 0;\n\t\toutline: none;\n\t\tpadding: 10px;\n\t\twidth: 100%;\n\t\tfont-weight: 500;\n\t\tdisplay: block;\n\t\t&::placeholder {\n\t\t\tcolor: #aaaaaa;\n\t\t}\n\t\t", "\n\t\t", ";\n\n\t\t&:focus::-webkit-input-placeholder {\n\t\t\tcolor: transparent;\n\t\t}\n\t\t&:focus:-moz-placeholder {\n\t\t\tcolor: transparent;\n\t\t}\n\t\t&:focus::-moz-placeholder {\n\t\t\tcolor: transparent;\n\t\t}\n\t\t&:focus:-ms-input-placeholder {\n\t\t\tcolor: transparent;\n\t\t}\n\t}\n"], ["\n\t {\n\t\tborder: 0;\n\t\toutline: none;\n\t\tpadding: 10px;\n\t\twidth: 100%;\n\t\tfont-weight: 500;\n\t\tdisplay: block;\n\t\t&::placeholder {\n\t\t\tcolor: #aaaaaa;\n\t\t}\n\t\t", "\n\t\t", ";\n\n\t\t&:focus::-webkit-input-placeholder {\n\t\t\tcolor: transparent;\n\t\t}\n\t\t&:focus:-moz-placeholder {\n\t\t\tcolor: transparent;\n\t\t}\n\t\t&:focus::-moz-placeholder {\n\t\t\tcolor: transparent;\n\t\t}\n\t\t&:focus:-ms-input-placeholder {\n\t\t\tcolor: transparent;\n\t\t}\n\t}\n"])), function (props) { return (props.deleted ? 'background-color: #eeeeee;' : ''); }, function (props) { return (props.deleted ? 'text-decoration: line-through;' : ''); });
exports.TextArea.displayName = 'TextArea';
var templateObject_1;
